import { Component, OnInit, Input } from '@angular/core';
import { DeliveryIndicator } from '../../models/delivery-indicator';
import { DeliverySearch } from '../../models/delivery-search';
import { ApiService } from '../../../../core/services/api.service';

@Component({
  selector: 'delivery-indicator',
  templateUrl: './delivery-indicator.component.html',
  styleUrls: ['./delivery-indicator.component.scss']
})

export class DeliveryIndicatorComponent implements OnInit {

  @Input()
  set search(search: DeliverySearch) {
    if (search) { this.getDeliveryIndicator(search); }
  }

  indicator: DeliveryIndicator;

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.indicator = new DeliveryIndicator();
  }

  private getDeliveryIndicator(search: DeliverySearch): void {
    this.apiService.get<DeliveryIndicator>('api/Delivery/getDeliveryIndicator/' + search.initDate.toISOString() + '/' + search.endDate.toISOString() + '/' + search.vehicle)
      .subscribe((response: DeliveryIndicator) => {
        if (response) {
          this.indicator = response;
        }
      });
  }

}
